import moment from 'moment';
import { useState } from 'react';
import { InfoText, InfoTitle, InfoWrapper } from 'components/new-ui/base/info-wrapper/styles';
import useManifests from 'hooks/useManifests';
import Button from 'components/new-ui/base/button/Button';
import AssignManifestModal from 'views/manifests/components/assign-manifest/AssignManifestModal';
import { StyledPaperRow } from 'components/new-ui/base/wrappers/styles';
import { getPortDisplayValue } from 'utils/getPortDisplayValue';
import { DeclarationCountry } from 'store/declarations/enums/common/declaration-country';

type Props = {
    canAssignManifests?: boolean;
};

const ManifestOverviewHeader = ({ canAssignManifests }: Props) => {
    const { manifest, getManifestById } = useManifests();

    const [openAssignModal, setOpenAssignModal] = useState(false);

    const formattedEta = moment(manifest?.declarationsData?.estimatedDateTimeOfArrival).format('DD/MM/YYYY HH:mm');

    let assignedTo: React.ReactNode = '-';
    if (manifest?.owner?.fullName) {
        assignedTo = manifest.owner.fullName;
    } else if (manifest?.owner?.email) {
        assignedTo = manifest.owner.email;
    } else if (canAssignManifests) {
        assignedTo = <Button type="assign" onClick={() => setOpenAssignModal(true)} />;
    }

    const departurePort = manifest?.departurePort;
    const arrivalPort = manifest?.declarationsData?.arrivalPort;
    const departurePortDisplayValue = departurePort;
    const arrivalPortDisplayValue = arrivalPort ? getPortDisplayValue(DeclarationCountry.IRELAND, arrivalPort) : '-';

    const route = departurePortDisplayValue
        ? `${departurePortDisplayValue} - ${arrivalPortDisplayValue}`
        : arrivalPortDisplayValue;

    return (
        <>
            <StyledPaperRow>
                <InfoWrapper key="trailerId">
                    <InfoTitle>Trailer ID:</InfoTitle>
                    <InfoText>{manifest?.declarationsData?.vehicleRegistration ?? '-'}</InfoText>
                </InfoWrapper>
                <InfoWrapper key="pbn">
                    <InfoTitle>PBN:</InfoTitle>
                    <InfoText>{manifest?.pbn ?? '-'}</InfoText>
                </InfoWrapper>
                <InfoWrapper key="haulier">
                    <InfoTitle>Haulier:</InfoTitle>
                    <InfoText>{manifest?.haulier ?? '-'}</InfoText>
                </InfoWrapper>
                <InfoWrapper key="imo">
                    <InfoTitle>IMO:</InfoTitle>
                    <InfoText>{manifest?.declarationsData?.meansOfTransportOnArrivalIdNumber ?? '-'}</InfoText>
                </InfoWrapper>
                <InfoWrapper key="eta">
                    <InfoTitle>ETA:</InfoTitle>
                    <InfoText>{formattedEta}</InfoText>
                </InfoWrapper>
                <InfoWrapper key="route">
                    <InfoTitle>Route:</InfoTitle>
                    <InfoText>{route}</InfoText>
                </InfoWrapper>
                <InfoWrapper key="assignedTo">
                    <InfoTitle>Assigned To:</InfoTitle>
                    <InfoText>{assignedTo}</InfoText>
                </InfoWrapper>
            </StyledPaperRow>

            {manifest && (
                <AssignManifestModal
                    open={openAssignModal}
                    manifest={manifest}
                    onClose={() => setOpenAssignModal(false)}
                    onSuccess={() => getManifestById(manifest.id)}
                />
            )}
        </>
    );
};

export default ManifestOverviewHeader;
